/**
 * Vue mixin to be used through out the app
 * TODO: Replace options api. Can we use setup method here?
 * TODO: Replace any with Lyra data type
 * 
 * Author: Sahil David
 */

import store from '@/bootstrap/services/store';
import { ILyraRecordOptions } from '../@types';

import { stripTags, assetHtml, citationHtml } from './lyra.helpers';

/**
 * Mixin object
 */
export default {
	methods: {
		/**
		 * Method to return lyra asset value
		 * @param key {string} asset key to derive value for
		 * @param options { ILyraRecordOptions } options to modify return asset value
		 * @returns - asset value queried
		 */
		$ly (key: string, options: ILyraRecordOptions = {}): string {
			const { noOuterTag, stripHtml } = options;

			const assets: any[] = store.getters.get_assets || [];
			const record = assets.find((_: any) => _.key === key);

			// Wrap record in HTML
			if (record && record.value) {
				const _value = record.value.value;
				const value = stripHtml ? stripTags(_value) : _value;
				return noOuterTag ? value : assetHtml(key, value);
			}

			// Return key on no record found
			console.warn(`[LYRA] No record found for asset key: ${key}`);
			return key;
		},
		/**
		 * Method to return if the lyra asset exists
		 * @param key {string} asset key to derive value for
		 * @returns - boolean indicating if the asset exist
		 */
		$lye (key: string): boolean {
			const assets: any[] = store.getters.get_assets || [];
	
			const record = assets.find((_: any) => _.key === key);
			return record && Object.keys(record || {}).length > 0;
		},
		/**
		 * Method to return lyra citation value
		 * @param key {string} citation key to derive value for
		 * @param options { ILyraRecordOptions } options to modify return citation value
		 * @returns - citation value queried
		 */
		$lc (key: string, options: ILyraRecordOptions = {}): string {
			const { noOuterTag, stripHtml } = options;

			const citations = store.getters.get_citations || [];
			const record = citations.find((_: any) => _.key === key);

			// Wrap record in HTML
			if (record && record.value) {
				const _value = record.value.value;
				const value = stripHtml ? stripTags(_value) : _value;
				return noOuterTag ? value : citationHtml(key, value);
			}

			// Return key on no record found
			console.warn(`[LYRA] No record found for citation key: ${key}`);
			return key;
		}
	}
}